import { use } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';

import TenantAccessIndicatorProviderContext from 'features/tenants/providers/tenant-access-indicator-provider/context/tenant-access-indicator-provider-context';
import styles from './tenant-access-indicator.module.scss';

const TenantAccessIndicator = (): React.JSX.Element => {
  const { t } = useTranslation('tenants');
  const {
    tenant: { name: tenantName },
  } = use(AuthProviderContext);
  const { originalUser, revertTemporaryTenantAccess } = use(TenantAccessIndicatorProviderContext);

  const renderAccessIndicator = (): React.JSX.Element => (
    <div className={styles.tenantAccessIndicator}>
      <div className={styles.tenantHeader}>
        <Typography variant="body1">{t('tenantAccessIndicator.customerRealmLabel')}</Typography>
        <Typography>&nbsp;</Typography>
        <Typography variant="h5">{tenantName ?? ''}</Typography>
      </div>
      <Button onClick={revertTemporaryTenantAccess}>{t('tenantAccessIndicator.exit')}</Button>
    </div>
  );

  return originalUser ? renderAccessIndicator() : <></>;
};

export default TenantAccessIndicator;
